// Cart bus shim — the sole publisher of PUB_SUB_EVENTS.cartUpdate.
// Monkey-patches window.fetch so every successful mutation of /cart/* endpoints
// publishes the cart-update event on the pubsub, regardless of which code path
// triggered the mutation (product-form submit, cart-dependency-manager,
// srd-widgets-akc, Rebuy SDK internal fetches, cart-items quantity changes).
//
// Must load AFTER pubsub.js and constants.js so `publish` and `PUB_SUB_EVENTS`
// are in scope as script-top-level bindings.
//
// Not an ES module — relies on classic-script shared top-level scope.

(function () {
  if (typeof window === 'undefined') return;
  if (typeof publish !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
    console.warn('[cart-bus-shim] pubsub.js / constants.js not loaded first. Aborting shim install.');
    return;
  }
  if (window.fetch && window.fetch.__akcCartShim) return;

  var CART_MUTATION_PATHS = new Set([
    '/cart/add',
    '/cart/change',
    '/cart/update',
    '/cart/clear',
  ]);

  function isCartMutationPath(url) {
    try {
      var path = new URL(url, window.location.origin).pathname.replace(/\.(json|js)$/, '');
      return CART_MUTATION_PATHS.has(path);
    } catch (e) {
      return false;
    }
  }

  function resolveMethod(input, init) {
    if (init && init.method) return init.method.toUpperCase();
    if (typeof Request !== 'undefined' && input instanceof Request) return input.method.toUpperCase();
    return 'GET';
  }

  function resolveUrl(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  var originalFetch = window.fetch.bind(window);

  var patched = function (input, init) {
    var url = resolveUrl(input);
    var method = resolveMethod(input, init);
    var fetchPromise = originalFetch(input, init);

    if (method !== 'POST' || !isCartMutationPath(url)) {
      return fetchPromise;
    }

    return fetchPromise.then(function (response) {
      response.clone().json().then(function (body) {
        // Shopify .js endpoints can return HTTP 200 with body.status === 422
        // on semantic errors (e.g. variant-not-in-cart on /cart/change.js).
        // Treat those as cart errors, not mutations.
        var bodyStatus = (body && typeof body.status === 'number') ? body.status : 200;
        var ok = response.ok && bodyStatus >= 200 && bodyStatus < 300;

        if (ok) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'cart-bus-shim',
            url: url,
            cartData: body,
          });
        } else {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'cart-bus-shim',
            url: url,
            errors: body,
          });
        }
      }).catch(function () {
        // Non-JSON body (rare; HTML redirect, 204, etc.). Do not publish.
      });

      return response;
    });
  };

  patched.__akcCartShim = true;
  window.fetch = patched;
})();
